<template>
  <div v-easyadmin="easyadminId" 
    class="w-100"
    :class="[contentType, {'bg-vodafone': content.theme == 'dark' && !content.background_color}]" 
    v-if="isContentVisibleToUser()" 
    :style="[theme]" slide-contact-component
  >
    <div class="position-relative overflow-hidden container h-100">
      <div 
        v-if="content.background_image"
        :style="{'background-image': getContentResponsiveImageURL('background_image')}"
        class="w-100 h-100 position-absolute-center bg-cover-center" 
      ></div>
      <div class="row justify-content-center h-100" :style="contentStyle">
        <div class="col-12 col-md-6 col-lg-8 d-flex flex-column px-4 px-md-3 text-column text-center justify-content-center align-items-center">
          <simple-text-component 
            class="contact-content py-5 px-3"
            :content="textContent"
            :opt-container-content="containerContent"
            :active-story="activeStory"
          ></simple-text-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  props: {
    activeStory: {
      type: Boolean
    }
  },
  computed: {
    contentStyle() {
      const style = {};

      if (!this.content.theme) {
        style["color"] = this.content.text_color ? this.content.text_color : "inherit";
      }

      if (!!this.content.background_color) {
        style["background-color"] = this.content.background_color;
      }

      return style;
    },
    textContent() {
      const {background_color, ...rest} = this.content;
      return rest;
    }
  },
};
</script>

<style lang="scss" scoped>
[slide-contact-component] {
  background-color: var(--theme-background);
  color: var(--theme-color);

  .text-column {
    z-index: 1;
    padding-top: var(--navigation-height);
    padding-bottom: var(--navigation-height);

    .contact-content {
      background: rgba(0, 0, 0, .35);
      backdrop-filter: blur(10px);
    }
  }
}
</style>
